/**
 * @Description: TODO 数学工具
 * @author wcd
 * @date 2020/2/21
 */

/**
 * @Description: todo 百分比计算
 * @author wcd
 * @date 2020/3/13
 */
export default {

  percentage(num, total) {
    try {
      num = parseFloat(num)
      total = parseFloat(total)
      if (isNaN(num) || isNaN(total)) {//非数字校验
        alert('非数字值')
        return '-'
      }
      return total <= 0 ? '0%' : (Math.round(num / total * 10000) / 100.00) + '%'
    } catch (e) {
      return console.error('换算失败：', e)
    }
  },

  /**
   * @Description: todo 百分数转小数
   * @author wcd
   * @date 2020/3/13
   */
  percentToInteger(percent) {
    try {
      let str = percent.replace('%', '')
      str = str / 100
      return str
    } catch (e) {
      return console.error('换算失败：', e)
    }
  },

  /**
   * @Description: todo 去除百分号
   * @author wcd
   * @date 2020/3/13
   */
  removePercent(percent) {
    try {
      return percent.replace('%', '')
    } catch (e) {
      return console.error('换算失败：', e)
    }
  },

  /**
   * @Description: todo 小数转百分数
   * @author wcd
   * @date 2020/3/13
   */
  pointToPercent(point) {
    try {
      let str = Number(point * 100).toFixed(1)
      str += '%'
      return str
    } catch (e) {
      return console.error('换算失败：', e)
    }
  },

  /**
   * @Description: todo 小数转整数【四舍五入】
   * @author wcd
   * @date 2020/3/13
   */
  pointToInteger(point) {
    try {
      return Math.round(point)
    } catch (e) {
      return console.error('换算失败：', e)
    }
  }

}



// WEBPACK FOOTER //
// ./src/utils/cdUtils/mathTools.js